import React, { useState, useEffect, useContext } from 'react';
import { servicesManager, hotkeysManager } from '../App.js';
import PropTypes from 'prop-types';
import OHIF from '@ohif/core';
import { withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { PageToolbar, useDebounce, useMedia, CustomView } from '@ohif/ui';
import ConnectedHeader from '../connectedComponents/ConnectedHeader.js';
import * as RoutesUtil from '../routes/routesUtil';
import moment from 'moment';
import ConnectedDicomFilesUploader from '../googleCloud/ConnectedDicomFilesUploader';
import ConnectedDicomStorePicker from '../googleCloud/ConnectedDicomStorePicker';
// import filesToStudies from '../lib/filesToStudies.js';
import AIPathSelect from '../components/AIPathSelect/AIPathSelect';
import { Menu, Dropdown } from 'antd';

// Contexts
import UserManagerContext from '../context/UserManagerContext';
import WhiteLabelingContext from '../context/WhiteLabelingContext';
import AppContext from '../context/AppContext';

import { Icon } from '@ohif/ui/src/elements/Icon';
import { Tooltip } from '@ohif/ui/src/components/tooltip';
import { OverlayTrigger } from '@ohif/ui/src/components/overlayTrigger';
import { Line } from 'rc-progress';
import MainList from './MainList.js';
import { getStudyLis2t, callAiCheck } from './makeData';
import useSearchParams from '../customHooks/useSearchParams';

const { urlUtil: UrlUtil } = OHIF.utils;

let timer = null; //定时器 定时刷新studylist

function StudyListRout2e(props) {
  const { history, server, user, studyListFunctionsEnabled } = props;
  const [t] = useTranslation('Common');
  // ~~ STATE
  const [sort] = useState({
    fieldName: 'PatientName',
    direction: 'desc',
  });

  const [studies] = useState([]);
  const [searchStatus, setSearchStatus] = useState({
    isSearchingForStudies: false,
    error: null,
  });
  const [activeModalId, setActiveModalId] = useState(null);
  const [searchParams] = useSearchParams();
  const [rowsPerPage, setRowsPerPage] = useState(
    Number(searchParams.rows) || 10
  );
  const [pageNumber, setPageNumber] = useState(
    Number(searchParams.page - 1) || 0
  );
  const [total, setTotal] = useState(0);
  const appContext = useContext(AppContext);
  // ~~ RESPONSIVE
  const displaySize = useMedia(
    [
      '(min-width: 1750px)',
      '(min-width: 1000px) and (max-width: 1749px)',
      '(max-width: 999px)',
    ],
    ['large', 'medium', 'small'],
    'small'
  );
  // ~~ DEBOUNCED INPUT
  const debouncedSort = useDebounce(sort, 200);
  // const debouncedFilters = useDebounce(filterValues, 250);

  // Google Cloud Adapter for DICOM Store Picking
  const { appConfig = {} } = appContext;
  const isGoogleCHAIntegrationEnabled =
    !server && appConfig.enableGoogleCloudAdapter;
  if (isGoogleCHAIntegrationEnabled && activeModalId !== 'DicomStorePicker') {
    setActiveModalId('DicomStorePicker');
  }

  const [initialSortBy, setInitialSortBy] = useState(
    searchParams.orderKey
      ? [
        {
          id:
            searchParams.orderKey === 'userName'
              ? 'userInfo'
              : searchParams.orderKey,
          desc: Boolean(Number(searchParams.orderRule)),
        },
      ]
      : []
  );
  // [
  //   { value: 'ZHOU FEI', label: 'ZHOU FEI', pid: 1, rid: 1, isSelect: false },
  //   {
  //     value: 'Hong Xian Mei',
  //     label: 'Hong Xian Mei',
  //     pid: 1,
  //     rid: 3,
  //     isSelect: false,
  //   },
  //   {
  //     value: 'tu xin min',
  //     label: 'tu xin min',
  //     pid: 1,
  //     rid: 6,
  //     isSelect: false,
  //   },
  //   { value: 'CT', label: 'CT', pid: 2, rid: 2, isSelect: false },
  //   { value: 'MR', label: 'MR', pid: 2, rid: 4, isSelect: false },
  //   {
  //     value: '体素肺结节',
  //     label: '体素肺结节',
  //     pid: 3,
  //     rid: 3,
  //     isSelect: false,
  //   },
  // ]
  const [filterValues, setFilterValues] = useState(
    searchParams.filter ? JSON.parse(sessionStorage.getItem('filterData')) : []
  );

  useEffect(() => {
    let search = `page=${pageNumber + 1}&rows=${rowsPerPage}`;
    if (initialSortBy.length) {
      const sortData = { ...initialSortBy[0] };
      if (sortData.id === 'userInfo') sortData.id = 'userName';
      search += `&orderKey=${sortData.id}&orderRule=${Number(sortData.desc)}`;
    }
    if (filterValues && filterValues.length > 0) {
      sessionStorage.setItem('filterData', JSON.stringify(filterValues));
      search += `&filter=true`;
    } else {
      sessionStorage.setItem('filterData', '');
    }
    history.push({ search });
  }, [filterValues, pageNumber, rowsPerPage, initialSortBy, history]);
  // Called when relevant state/props are updated
  // Watches filters and sort, debounced
  useEffect(
    () => {
      const fetchStudyList = async () => {
        try {
          const result = await getStudyLis2t(
            filterValues,
            rowsPerPage,
            pageNumber,
            {
              orderKey: searchParams.orderKey,
              orderRule: searchParams.orderRule,
            },
            appConfig
          );
          result.data.records = result.data.records.map(i => {
            // i.result = '阴性';
            i.userInfo = JSON.stringify({
              userName: i.userName,
              age: i.age,
              gender: i.gender,
            });
            i.checkInfo = JSON.stringify({
              id: i.patientId,
              time: i.studyDate,
            });
            i.checkTime = JSON.stringify({
              str: i.aiAnalyseStartTime,
              end: i.aiAnalyseEndTime,
            });
            i.aiInfo = JSON.stringify({
              percent: i.progressPer,
              path: i.aiCheckPath,
              device: i.device,
              id: i.id,
            });
            // ("-1","未分析"),("00","AI分析中"),("05","分析完成"),("08","分析出错"),("10","待确认"),("20","确认中"),("30","确认完成"),("40","阅片中"),("50","阅片完成");
            i.statusInfo = JSON.stringify({
              process: i.process,
              code: i.processCode,
              tip: i.remark,
            });
            i.p3 = JSON.stringify({
              studyId: i.studyId,
              id: i.id,
              viewed: i.viewed,
              resultUrls: i.resultUrls,
            });
            return i;
          });
          setTotal(result.data.total);
          setData(result.data.records);
        } catch (error) {
          console.warn(error);
          // setSearchStatus({ error: true, isFetching: false });
        }
      };
      if (server) {
        fetchStudyList();
      }
      timer = setInterval(() => {
        fetchStudyList();
      }, 50000);

      return () => {
        clearInterval(timer);
      };
    },
    // TODO: Can we update studies directly?
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      filterValues,
      debouncedSort,
      rowsPerPage,
      pageNumber,
      displaySize,
      server,
      searchParams.orderKey,
      searchParams.orderRule,
    ]
  );

  // if (searchStatus.error) {
  //   return <div>Error: {JSON.stringify(searchStatus.error)}</div>;
  // } else if (studies === [] && !activeModalId) {
  //   return <div>Loading...</div>;
  // }

  if (studies === [] && !activeModalId) {
    return <div>Loading...</div>;
  }

  let healthCareApiButtons = null;
  let healthCareApiWindows = null;

  if (appConfig.enableGoogleCloudAdapter) {
    const isModalOpen = activeModalId === 'DicomStorePicker';
    updateURL(isModalOpen, appConfig, server, history);

    healthCareApiWindows = (
      <ConnectedDicomStorePicker
        isOpen={activeModalId === 'DicomStorePicker'}
        onClose={() => setActiveModalId(null)}
      />
    );

    healthCareApiButtons = (
      <div
        className="form-inline btn-group pull-right"
        style={{ padding: '20px' }}
      >
        <button
          className="btn btn-primary"
          onClick={() => setActiveModalId('DicomStorePicker')}
        >
          {t('Change DICOM Store')}
        </button>
      </div>
    );
  }

  const [data, setData] = useState([]);
  const column2s = [
    {
      title: '个人信息',
      width: 116,
      dataIndex: 'userInfo',
      key: 'userInfo',
      render(_, record) {
        return (
          <>
            {
              <div>
                <div>
                  {record.userName && record.userName.length > 12 ? (
                    <OverlayTrigger
                      key={1}
                      placement="top"
                      overlay={
                        <Tooltip
                          placement="top"
                          className="in tooltip-warning"
                          id="tooltip-top"
                        >
                          <div className="warningContent">
                            {record.userName}
                          </div>
                        </Tooltip>
                      }
                    >
                      <div>{record.userName.substring(0, 14) + '...'}</div>
                    </OverlayTrigger>
                  ) : (
                    record.userName
                  )}
                </div>
                <div>
                  <span>{record.gender}</span>
                  <span style={{ marginLeft: '15px' }}>{record.age}</span>
                </div>
              </div>
            }
          </>
        );
      },
      sorter: true,
    },
    {
      title: '设备',
      width: 82,
      dataIndex: 'device',
      key: 'device',
      sorter: true,
    },
    {
      title: '检查项目',
      width: 150,
      dataIndex: 'name',
      key: 'name',
      render(_, record) {
        return (
          <>
            {record.name && record.name.length > 9 ? (
              <OverlayTrigger
                key={1}
                placement="top"
                overlay={
                  <Tooltip
                    placement="top"
                    className="in tooltip-warning"
                    id="tooltip-top"
                  >
                    <div className="warningContent">{record.name}</div>
                  </Tooltip>
                }
              >
                <div>{record.name.substring(0, 6) + '...'}</div>
              </OverlayTrigger>
            ) : (
              record.name
            )}
          </>
        );
      },
      sorter: true,
    },
    {
      title: '请求ID',
      width: 120,
      dataIndex: 'p2',
      key: 'p2',
      render(_, record) {
        return (
          <>
            {record.p2 && record.p2.length > 13 ? (
              <OverlayTrigger
                key={1}
                placement="top"
                overlay={
                  <Tooltip
                    placement="top"
                    className="in tooltip-warning"
                    id="tooltip-top"
                  >
                    <div className="warningContent">{record.p2}</div>
                  </Tooltip>
                }
              >
                <div>{record.p2.substring(0, 10) + '...'}</div>
              </OverlayTrigger>
            ) : (
              record.p2
            )}
          </>
        );
      },
    },
    {
      title: '发起时间',
      width: 180,
      dataIndex: 'createTime',
      render: text => (text ? moment(text).format('YYYY/MM/DD HH:mm:ss') : ''),
    },
    {
      title: '检查号/时间',
      width: 120,
      dataIndex: 'checkInfo',
      render(_, record) {
        return (
          <>
            {
              <div>
                <div>{record.patientId}</div>
                <div>
                  {record.studyDate
                    ? moment(record.studyDate).format('YYYY/MM/DD')
                    : ''}
                </div>
              </div>
            }
          </>
        );
      },
    },
    {
      title: '报告状态',
      width: 180,
      dataIndex: 'statusInfo',
      key: 'statusInfo',
      render(_, record) {
        let backgroundColor = '';
        if (record.processCode == '05') {
          backgroundColor = '#91B9CD';
        } else if (record.processCode == '00') {
          backgroundColor = '#2AA726';
        } else if (record.processCode == '-1') {
          backgroundColor = '#A78526';
        } else if (record.processCode == '08') {
          backgroundColor = 'red';
        } else {
          backgroundColor = '#A78526';
        }
        return (
          <>
            <div>
              {record.processCode == '08' && record.remark ? (
                <OverlayTrigger
                  key={1}
                  placement="top"
                  overlay={
                    <Tooltip
                      placement="top"
                      className="in tooltip-warning"
                      id="tooltip-top"
                    >
                      <div className="warningContent">{record.remark}</div>
                    </Tooltip>
                  }
                >
                  <div>
                    <span
                      style={{
                        color: '#fff',
                        backgroundColor: backgroundColor,
                        fontSize: '12px',
                        padding: '4px 8px',
                        borderRadius: '12px',
                        wordBreak: 'keep-all',
                      }}
                    >
                      {record.process}
                    </span>
                  </div>
                </OverlayTrigger>
              ) : (
                <span
                  style={{
                    color: '#fff',
                    backgroundColor: backgroundColor,
                    fontSize: '12px',
                    padding: '4px 8px',
                    borderRadius: '12px',
                    wordBreak: 'keep-all',
                  }}
                >
                  {record.process}
                </span>
              )}
            </div>
          </>
        );
      },
      sorter: true,
    },
    {
      title: '报告完成时间',
      width: 170,
      dataIndex: 'reportFinishTime',
      render: text => (text ? moment(text).format('YYYY/MM/DD HH:mm:ss') : ''),
    },
    {
      title: 'AI匹配路径',
      width: 281,
      dataIndex: 'aiInfo',
      key: 'aiInfo',
      render(_, record) {
        // const aiInfo = JSON.parse(values);
        const percent = record.progressPer.replace('%', '');
        return (
          <>
            <div
              style={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <AIPathSelect
                appConfig={appConfig}
                id={record.id}
                name={record.aiCheckPath}
                device={record.device}
                getNewAICheckPath={newAICheckPath}
                inDialog={false}
                showDialog={true}
              />
              <div>
                <div
                  style={{
                    width: '230px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {
                    <Line
                      percent={percent}
                      prefixCls="0"
                      strokeWidth="5"
                      trailWidth="5"
                      strokeColor="#91B9CD"
                      style={{ marginRight: '10px' }}
                    />
                  }
                  {record.progressPer}
                </div>
              </div>
            </div>
          </>
        );
      },
    },
    {
      title: 'AI分析起止时间',
      width: 180,
      dataIndex: 'checkTime',
      key: 'checkTime',
      render(_, record) {
        return (
          <>
            {
              <div>
                <div>
                  {record.aiAnalyseStartTime
                    ? moment(record.aiAnalyseStartTime).format(
                      'YYYY/MM/DD HH:mm:ss'
                    )
                    : ''}
                </div>
                <div>
                  {record.aiAnalyseEndTime
                    ? moment(record.aiAnalyseEndTime).format(
                      'YYYY/MM/DD HH:mm:ss'
                    )
                    : ''}
                </div>
              </div>
            }
          </>
        );
      },
    },
    {
      title: 'AI结果',
      width: 94,
      dataIndex: 'generalResult',
      key: 'generalResult',
      fixed: 'right',
      render(_, record) {
        return (
          <>
            {record.generalResult == '阴性' && (
              <span>{record.generalResult}</span>
            )}
            {record.generalResult == '阳性' && (
              <span
                style={{
                  color: '#D91818',
                }}
              >
                {record.generalResult}
              </span>
            )}
          </>
        );
      },
    },
    {
      title: '查看AI',
      width: 80,
      dataIndex: 'p3',
      key: 'p3',
      fixed: 'right',
      render(_, record) {
        const options = [];
        let menu;
        if (record.resultUrls && record.resultUrls.length == 1) {
          if (record.resultUrls[0].urlType != '0') {
            options.push(1);
            menu = (
              <Menu>
                <Menu.Item
                  key="0"
                  style={{
                    background: '#fff',
                  }}
                >
                  <a onClick={() => rowValue(record.studyId, record.id)}>
                    {record.resultUrls[0].aiName}
                  </a>
                </Menu.Item>
              </Menu>
            );
          }
        }
        if (record.resultUrls && record.resultUrls.length > 1) {
          menu = (
            <Menu>
              {record.resultUrls.map((item, index) => {
                if (item.urlType == '0') {
                  return (
                    <Menu.Item key={index} className="study-dropdown-menu-item">
                      <a onClick={() => rowValue(record.studyId, record.id)}>
                        {item.aiName}
                      </a>
                    </Menu.Item>
                  );
                } else {
                  if (item.pdfUrl) {
                    return (
                      <Menu.Item
                        key={index}
                        className="study-dropdown-menu-item"
                      >
                        <a onClick={() => openPdf(record.studyId, item.pdfUrl)}>
                          {item.aiName}
                        </a>
                      </Menu.Item>
                    );
                  }
                  if (item.viewerUrl) {
                    return (
                      <Menu.Item
                        key={index}
                        className="study-dropdown-menu-item"
                      >
                        <a
                          onClick={() =>
                            openUrl(record.studyId, item.viewerUrl)
                          }
                        >
                          {item.aiName}
                        </a>
                      </Menu.Item>
                    );
                  }
                }
              })}
            </Menu>
          );
          record.resultUrls.map(item => {
            if (item.urlType == '0') {
              options.push('1');
            } else {
              if (item.pdfUrl) {
                options.push('1');
              }
              if (item.viewerUrl) {
                options.push('1');
              }
            }
          });
        }
        return (
          <>
            {options.length > 0 && (
              <Dropdown
                overlay={menu}
                trigger={['click']}
                placement="bottomRight"
                overlayClassName="study-dropdown"
              >
                <a
                  className="ant-dropdown-link"
                  onClick={e => e.preventDefault()}
                >
                  <Icon name="view" />
                </a>
              </Dropdown>
            )}
            {options.length == 0 && (
              <div onClick={() => rowValue(record.studyId, record.id)}>
                {record.viewed === '1' && <Icon name="view" />}
                {record.viewed === '0' && <Icon name="view-no" />}
              </div>
            )}
          </>
        );
      },
    },
  ];

  const rowValue = async (studyId, aiCheckId) => {
    const { hotkeyDefinitions } = hotkeysManager;
    let hotkeys = { ...hotkeyDefinitions };
    for (let key in hotkeys) {
      if (hotkeys[key].type === 'mark') {
        delete hotkeys[key];
      }
    }
    hotkeysManager.setHotkeys(hotkeys);

    const viewerPath = RoutesUtil.parseViewerPath(appConfig, server, {
      studyInstanceUIDs: studyId,
      aiCheckId: aiCheckId,
    });
    history.push({
      pathname: viewerPath,
      // state: { aiCheckId: aiCheckId },
      search: `aiCheckId=${aiCheckId}`,
    });
  };

  const openUrl = async (studyId, api_url) => {
    window.open(api_url);
  };

  const openPdf = async (event, api_url) => {
    const filename = 'test.zip';
    const aElement = document.createElement('a');
    document.body.appendChild(aElement);
    aElement.style.display = 'none';
    aElement.target = '_blank';
    aElement.href = api_url;
    aElement.download = filename;
    aElement.click();
    document.body.removeChild(aElement);
  };

  //获取新的AI匹配路劲
  const newAICheckPath = async (dicAiCheckId, id) => {
    let payload = {
      id: id,
      dicAiCheckId: dicAiCheckId,
    };
    // async saveAiCheck(payload) {
    const { UINotificationService } = servicesManager.services;

    let res = await callAiCheck(payload, appConfig);
    if (res.status === 'success') {
      const message = '';
      UINotificationService.show({
        title: '保存成功',
        message,
        type: 'info',
      });
      filtersChange();
    } else {
      console.log(res);
    }
    // }
  };

  const filtersChange = async e => {
    setFilterValues(e);
  };

  const onTableChange = (pagination, filters, sorter) => {
    const id = sorter.columnKey;
    const desc = sorter.order === 'descend';
    setInitialSortBy(sorter.order ? [{ id, desc }] : []);
    setPageNumber(pagination.current - 1);
  };

  return (
    <>
      {studyListFunctionsEnabled ? (
        <ConnectedDicomFilesUploader
          isOpen={activeModalId === 'DicomFilesUploader'}
          onClose={() => setActiveModalId(null)}
        />
      ) : null}
      {healthCareApiWindows}
      <WhiteLabelingContext.Consumer>
        {whiteLabeling => (
          <UserManagerContext.Consumer>
            {userManager => (
              <ConnectedHeader
                useLargeLogo={true}
                user={user}
                userManager={userManager}
              >
                {whiteLabeling &&
                  whiteLabeling.createLogoComponentFn &&
                  whiteLabeling.createLogoComponentFn(React)}
              </ConnectedHeader>
            )}
          </UserManagerContext.Consumer>
        )}
      </WhiteLabelingContext.Consumer>
      <div className="study-list-header">
        <div className="header">
          <h1 style={{ fontWeight: 300, fontSize: '22px' }}>{t('检查列表')}</h1>
        </div>
        <div className="actions">
          {studyListFunctionsEnabled && healthCareApiButtons}
          {studyListFunctionsEnabled && (
            <PageToolbar
              onImport={() => setActiveModalId('DicomFilesUploader')}
            />
          )}
          {/* <span className="study-count">{studies.length}</span> */}
          <span className="study-count">{total}</span>
        </div>
      </div>

      {/* <div className="table-head-background" /> */}
      <div className="study-list-container">
        <div
          style={{
            position: 'relative',
            zIndex: '1',
          }}
        >
          <MainList
            columns={column2s}
            getRowValue={rowValue}
            getFiltersChange={filtersChange}
            data={data}
            // initialSortBy={initialSortBy}
            pagination={{
              size: 'small',
              showSizeChanger: true,
              total,
              current: pageNumber + 1,
              defaultPageSize: rowsPerPage,
              onShowSizeChange: (_, row) => setRowsPerPage(row),
            }}
            appConfig={appConfig}
            filter={filterValues}
            onChange={onTableChange}
          />
        </div>
      </div>
    </>
  );
}

StudyListRout2e.propTypes = {
  filters: PropTypes.object,
  PatientID: PropTypes.string,
  server: PropTypes.object,
  user: PropTypes.object,
  history: PropTypes.object,
  studyListFunctionsEnabled: PropTypes.bool,
};

StudyListRout2e.defaultProps = {
  studyListFunctionsEnabled: true,
};

function updateURL(isModalOpen, appConfig, server, history) {
  if (isModalOpen) {
    return;
  }

  const listPath = RoutesUtil.parseStudyListPath(appConfig, server);

  if (UrlUtil.paramString.isValidPath(listPath)) {
    const { location = {} } = history;
    if (location.pathname !== listPath) {
      history.replace(listPath);
    }
  }
}

/**
 * Not ideal, but we use displaySize to determine how the filters should be used
 * to build the collection of promises we need to fetch a result set.
 *
 * @param {*} server
 * @param {*} filters
 * @param {object} sort
 * @param {string} sort.fieldName - field to sort by
 * @param {string} sort.direction - direction to sort
 * @param {number} rowsPerPage - Number of results to return
 * @param {number} pageNumber - Used to determine results offset
 * @param {string} displaySize - small, medium, large
 * @returns
 */
async function getStudyList(
  server,
  filters,
  sort,
  rowsPerPage,
  pageNumber,
  displaySize
) {
  const {
    allFields,
    patientNameOrId,
    accessionOrModalityOrDescription,
  } = filters;
  const sortFieldName = sort.fieldName || 'PatientName';
  const sortDirection = sort.direction || 'desc';

  const mappedFilters = {
    PatientID: filters.PatientID,
    PatientName: filters.PatientName,
    AccessionNumber: filters.AccessionNumber,
    StudyDescription: filters.StudyDescription,
    ModalitiesInStudy: filters.modalities,
    // NEVER CHANGE
    studyDateFrom: filters.studyDateFrom,
    studyDateTo: filters.studyDateTo,
    limit: rowsPerPage,
    offset: pageNumber * rowsPerPage,
    fuzzymatching: server.supportsFuzzyMatching === true,
  };

  const studies = await _fetchStudies(server, mappedFilters, displaySize, {
    allFields,
    patientNameOrId,
    accessionOrModalityOrDescription,
  });

  // Only the fields we use
  const mappedStudies = studies.map(study => {
    const PatientName =
      typeof study.PatientName === 'string' ? study.PatientName : undefined;

    return {
      AccessionNumber: study.AccessionNumber, // "1"
      modalities: study.modalities, // "SEG\\MR"
      // numberOfStudyRelatedInstances: "3"
      // numberOfStudyRelatedSeries: "3"
      // PatientBirthdate: undefined
      PatientID: study.PatientID, // "NOID"
      PatientName, // "NAME^NONE"
      // PatientSex: "M"
      // referringPhysicianName: undefined
      StudyDate: study.StudyDate, // "Jun 28, 2002"
      StudyDescription: study.StudyDescription, // "BRAIN"
      // studyId: "No Study ID"
      StudyInstanceUID: study.StudyInstanceUID, // "1.3.6.1.4.1.5962.99.1.3814087073.479799962.1489872804257.3.0"
      // StudyTime: "160956.0"
    };
  });

  // For our smaller displays, map our field name to a single
  // field we can actually sort by.
  const sortFieldNameMapping = {
    allFields: 'PatientName',
    patientNameOrId: 'PatientName',
    accessionOrModalityOrDescription: 'modalities',
  };
  const mappedSortFieldName =
    sortFieldNameMapping[sortFieldName] || sortFieldName;

  const sortedStudies = _sortStudies(
    mappedStudies,
    mappedSortFieldName,
    sortDirection
  );

  // Because we've merged multiple requests, we may have more than
  // our Rows per page. Let's `take` that number from our sorted array.
  // This "might" cause paging issues.
  const numToTake =
    sortedStudies.length < rowsPerPage ? sortedStudies.length : rowsPerPage;
  const result = sortedStudies.slice(0, numToTake);

  return result;
}

/**
 *
 *
 * @param {object[]} studies - Array of studies to sort
 * @param {string} studies.StudyDate - Date in 'MMM DD, YYYY' format
 * @param {string} field - name of properties on study to sort by
 * @param {string} order - 'asc' or 'desc'
 * @returns
 */
function _sortStudies(studies, field, order) {
  // Make sure our StudyDate is in a valid format and create copy of studies array
  const sortedStudies = studies.map(study => {
    if (!moment(study.StudyDate, 'MMM DD, YYYY', true).isValid()) {
      study.StudyDate = moment(study.StudyDate, 'YYYYMMDD').format(
        'MMM DD, YYYY'
      );
    }
    return study;
  });

  // Sort by field
  sortedStudies.sort(function (a, b) {
    let fieldA = a[field];
    let fieldB = b[field];
    if (field === 'StudyDate') {
      fieldA = moment(fieldA).toISOString();
      fieldB = moment(fieldB).toISOString();
    }

    // Order
    if (order === 'desc') {
      if (fieldA < fieldB) {
        return -1;
      }
      if (fieldA > fieldB) {
        return 1;
      }
      return 0;
    } else {
      if (fieldA > fieldB) {
        return -1;
      }
      if (fieldA < fieldB) {
        return 1;
      }
      return 0;
    }
  });

  return sortedStudies;
}

/**
 * We're forced to do this because DICOMWeb does not support "AND|OR" searches
 * across multiple fields. This allows us to make multiple requests, remove
 * duplicates, and return the result set as if it were supported
 *
 * @param {object} server
 * @param {Object} filters
 * @param {string} displaySize - small, medium, or large
 * @param {string} multi.allFields
 * @param {string} multi.patientNameOrId
 * @param {string} multi.accessionOrModalityOrDescription
 */
async function _fetchStudies(
  server,
  filters,
  displaySize,
  { allFields, patientNameOrId, accessionOrModalityOrDescription }
) {
  let queryFiltersArray = [filters];

  if (displaySize === 'small') {
    const firstSet = _getQueryFiltersForValue(
      filters,
      [
        'PatientID',
        'PatientName',
        'AccessionNumber',
        'StudyDescription',
        'ModalitiesInStudy',
      ],
      allFields
    );

    if (firstSet.length) {
      queryFiltersArray = firstSet;
    }
  } else if (displaySize === 'medium') {
    const firstSet = _getQueryFiltersForValue(
      filters,
      ['PatientID', 'PatientName'],
      patientNameOrId
    );

    const secondSet = _getQueryFiltersForValue(
      filters,
      ['AccessionNumber', 'StudyDescription', 'ModalitiesInStudy'],
      accessionOrModalityOrDescription
    );

    if (firstSet.length || secondSet.length) {
      queryFiltersArray = firstSet.concat(secondSet);
    }
  }

  const queryPromises = [];

  queryFiltersArray.forEach(filter => {
    const searchStudiesPromise = OHIF.studies.searchStudies(server, filter);
    queryPromises.push(searchStudiesPromise);
  });

  const lotsOfStudies = await Promise.all(queryPromises);
  const studies = [];

  // Flatten and dedupe
  lotsOfStudies.forEach(arrayOfStudies => {
    if (arrayOfStudies) {
      arrayOfStudies.forEach(study => {
        if (!studies.some(s => s.StudyInstanceUID === study.StudyInstanceUID)) {
          studies.push(study);
        }
      });
    }
  });

  return studies;
}

/**
 *
 *
 * @param {*} filters
 * @param {*} fields - Array of string fields
 * @param {*} value
 */
function _getQueryFiltersForValue(filters, fields, value) {
  const queryFilters = [];

  if (value === '' || !value) {
    return queryFilters;
  }

  fields.forEach(field => {
    const filter = Object.assign(
      {
        PatientID: '',
        PatientName: '',
        AccessionNumber: '',
        StudyDescription: '',
        ModalitiesInStudy: '',
      },
      filters
    );

    filter[field] = value;
    queryFilters.push(filter);
  });

  return queryFilters;
}

export default withRouter(StudyListRout2e);
